import { Reveal, Overline } from "./Reveal";

const STEPS = [
  { num: "01", title: "Insérez", text: "Placez SOLAMOVE dans vos chaussures compatibles.", color: "#A8B89A" },
  { num: "02", title: "Marchez", text: "Continuez votre journée normalement, comme vous le faites déjà.", color: "#D4B3AD" },
  { num: "03", title: "Vivez", text: "SOLAMOVE reste dans vos chaussures et vous accompagne, simplement.", color: "#0D0D0D" },
];

export const HowItWorks = () => (
  <section data-testid="how-it-works-section" className="py-28 sm:py-40 bg-white border-y border-black/[0.06]">
    <div className="max-w-[1400px] mx-auto px-6 sm:px-10">
      <div className="mb-20 max-w-3xl">
        <Reveal><Overline>03 — Comment ça marche ?</Overline></Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-display uppercase tracking-tight leading-[1.02] text-4xl sm:text-6xl mt-6">
            Trois gestes.<br />Zéro effort en plus.
          </h2>
        </Reveal>
      </div>
      <div className="grid md:grid-cols-3 border-t border-black/[0.08]">
        {STEPS.map((step, i) => (
          <Reveal key={step.num} delay={i * 0.15} className={`py-12 md:px-10 ${i > 0 ? "md:border-l border-black/[0.08]" : "md:pl-0"} border-b md:border-b-0 border-black/[0.08]`}>
            <p className="font-mono-alt text-xs tracking-[0.3em]" style={{ color: step.color }}>{step.num}</p>
            <h3 className="font-display uppercase text-3xl sm:text-4xl mt-6 tracking-tight">{step.title}</h3>
            <p className="mt-4 text-[#6E6A66] leading-relaxed">{step.text}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
